module.exports = __webpack_public_path__ + "static/media/1350_Cart_Medical_thanksPopup.35a5d95d.png";